import axios from "axios";

const logInAPI = axios.create();

logInAPI.defaults.baseURL = "https://iot-api.sangsang.farm/v1/user/login";

export const logIn = (id: string, password: string) =>
  logInAPI.post("", { id, password });
